export class ListQueryExecutionsRequestFiltersStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<QueryExecutionStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<QueryExecutionStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequestFiltersStatus.attributeTypeMap;
    }
    constructor() {
    }
}
